export const ROLE_OPTIONS = [
  { value: "client-admin", label: "Client Admin" },
  { value: "member", label: "Member" },
  { value: "platform-admin", label: "Platform Admin" },
  { value: "programme-lead", label: "Programme Lead" },
  { value: "builder", label: "Builder" },
  { value: "reviewer", label: "Reviewer" },
  { value: "approver", label: "Approver" },
  { value: "viewer", label: "Viewer" },
  { value: "deactivated", label: "Deactivated" },
];

export const TENANT_ROLE_OPTIONS = [
  { value: "member", label: "Member" },
  { value: "client-admin", label: "Client Admin" },
];

export const RESPONSIBILITY_OPTIONS = [
  { value: "lead", label: "Lead" },
  { value: "builder", label: "Builder" },
  { value: "reviewer", label: "Reviewer" },
  { value: "approver", label: "Approver" },
  { value: "viewer", label: "Viewer" },
];

export function roleLabel(role: string): string {
  if (role === "reader") {
    return "Viewer";
  }
  return ROLE_OPTIONS.find((option) => option.value === role)?.label ?? role;
}

export function responsibilityLabel(responsibility: string): string {
  if (responsibility === "reader") {
    return "Viewer";
  }
  return (
    RESPONSIBILITY_OPTIONS.find((option) => option.value === responsibility)?.label ??
    responsibility
  );
}
